<template>
  <div class="container d-flex flex-column">
    <Logged-user />
    <div class="row">
      <div class="col-12 col-lg-6">
        <div class="row mt-4">
          <div class="col-12">
            <h4>Devenir adhérent Lettre Compte Triple
              <img src="/static/thumb-up.svg" class="icon" width="30"/>
            </h4>
          </div>
          <div class="col-12">
            Soutenez LCT en devenant adhérent !<br />
            Lettre Compte Triple c'est des heures et des heures de travail
            (sur leur temps libre) pour Aude et Sylvain.<br />
            L'objectif, après 10 ans d'existence,
            est toujours de proposer à tous un jeu en ligne clair
            et simple. Cependant il y a quelques frais de fonctionnement.<br />
            Devenir adhérent c'est :
            <ul>
              <li>Contribuer à la réussite du site en participant aux frais de fonctionnement</li>
              <li>Ne plus avoir de publicité</li>
            </ul>
            Les adhésions sont valables 1 an.
          </div>
        </div>
      </div>
      <div class="col-12 col-lg-6">
        <div class="row mt-4" v-if="chooseAmount">
          <div class="col-12">
            <h4>Je souhaite adhérer :</h4>
          </div>
          <div class="col-12">
            <div class="form-check d-none">
              <input class="form-check-input" v-on:click="showValidate = true"
              type="radio" id="amount0" v-model="pickamount" value="0">
              <label class="form-check-label" for="amount0">
                0€ - J'aime LCT mais je ne souhaite pas participer financièrement.
              </label>
            </div>
            <div class="form-check">
              <input class="form-check-input" v-on:click="showValidate = true"
              type="radio" id="amount5" v-model="pickamount" value="500">
              <label class="form-check-label" for="amount5">
                5€ - je joue occasionnellement.
              </label>
            </div>
            <div class="form-check">
              <input class="form-check-input" v-on:click="showValidate = true"
              type="radio" id="amount12" v-model="pickamount" value="1200">
              <label class="form-check-label" for="amount12">
                12€ - je joue régulièrement.
              </label>
            </div>
            <div class="form-row align-items-center">
              <div class="col-auto">
                <div class="form-check">
                  <input class="form-check-input" v-on:click="showValidate = true"
                  type="radio" id="amount-1" v-model="pickamount" value="-1">
                  <label class="form-check-label" for="amount-1">
                    Contribution libre
                  </label>
                </div>
              </div>
              <div class="col-auto">
                <label class="visually-hidden" for="inlineFormInputGroup">Montant</label>
                <div class="input-group mb-2">
                  <input type="text" class="form-control"
                  id="inlineFormInputGroup"
                  placeholder="Montant"
                  v-model="amount">
                  <div class="input-group-text">€</div>
                </div>
              </div>
            </div>
          </div>
          <div class="col-12">
              <button class="btn btn-primary"
              :disabled="!showValidate || redirecting"
              v-on:click="startCheckout">Valider</button>
          </div>
          <div class="col-12 mt-2">
            <small class="text-muted">Le paiement se fait sur la page sécurisée de
            <a href="https://stripe.com/fr" target="_blank">Stripe</a>.
            LCT ne garde aucune donnée bancaire.</small>
          </div>
          <div class="col-12 mt-2" v-if="amountError">{{amountError}}</div>
          <div class="col-12 mt-2" v-if="canceled">
            Paiement annulé : aucun montant n'a été prélevé.
          </div>
        </div>
        <div class="row mt-4" v-if="confirming">
          <h4 class="col-12">Vérification du paiement…</h4>
        </div>
        <div class="row mt-4" v-if="paymentPending">
          <h4 class="col-12">Paiement en cours de validation</h4>
          <div class="col-12">
            Votre paiement est en cours de validation par votre banque.
            Votre compte deviendra prémium dès qu'il sera confirmé.
          </div>
        </div>
        <div class="row mt-4" v-if="paymentValidated">
          <h4 class="col-12">Merci de votre soutien</h4>
          <div class="col-12">
            Vous êtes maintenant un utilisateur prémium.<br />
            Merci beaucoup de la reconnaissance du travail accompli pour faire marcher ce jeu.
          </div>
          <div class="col-12 mt-4">
            <button class="btn btn-link" v-on:click="$router.push('/lobby')">
            Retour à l'accueil
            </button>
          </div>
        </div>
        <div class="row mt-4" v-if="paymentError">
          <h4 class="col-12">{{errorTitle}}</h4>
          <div class="col-12">
              {{paymentError}}
          </div>
        </div>
      </div>
    </div>
    <div class="mt-auto">
      <bottom-nav />
    </div>
  </div>
</template>

<script>
import iam from '../iam';
import LoggedUser from './LoggedUser.vue';
import BottomNav from './BottomNav.vue';

// Montants en centimes acceptés par le serveur
const MIN_AMOUNT = 100;
const MAX_AMOUNT = 100000;

export default {
  name: 'SupportLCT',
  data() {
    return {
      pickamount: undefined,
      amount: undefined,
      showValidate: false,
      chooseAmount: true,
      amountError: undefined,
      canceled: false,
      redirecting: false,
      confirming: false,
      paymentPending: false,
      paymentError: undefined,
      errorTitle: 'Erreur, paiement non effectué',
      paymentValidated: false,
    };
  },
  components: { LoggedUser, BottomNav },
  created() {
    const { session_id: sessionId, annule } = this.$route.query;
    if (sessionId) {
      this.confirmPayment(sessionId);
    } else if (annule) {
      this.canceled = true;
    }
    // retour par le bouton Précédent depuis Stripe : page restaurée telle quelle, bouton à réactiver
    window.addEventListener('pageshow', this.onPageShow);
  },
  beforeUnmount() {
    window.removeEventListener('pageshow', this.onPageShow);
  },
  methods: {
    onPageShow(event) {
      if (event.persisted) {
        this.redirecting = false;
      }
    },
    // Page de paiement Stripe Checkout : le joueur y paie puis revient sur /support?session_id=…
    startCheckout() {
      const amount = this.pickamount >= 0 ? Number(this.pickamount)
        : Math.round(Number(String(this.amount).replace(',', '.').trim()) * 100);
      if (!Number.isInteger(amount) || amount < MIN_AMOUNT || amount > MAX_AMOUNT) {
        this.amountError = `Le montant doit être compris entre ${MIN_AMOUNT / 100} € et ${MAX_AMOUNT / 100} €.`;
        return;
      }
      this.amountError = undefined;
      this.canceled = false;
      this.paymentError = undefined;
      this.redirecting = true;
      this.$http.post(`${import.meta.env.VITE_LCT_API_URL}/payment-intents`, {
        amount,
      }).then((response) => {
        window.location.assign(response.data.url);
      }).catch(() => {
        this.redirecting = false;
        this.paymentError = 'La page de paiement n\'a pas pu être ouverte. Merci de réessayer plus tard.';
      });
    },
    // Retour de Stripe : le serveur vérifie la session auprès de Stripe et passe le compte premium
    confirmPayment(sessionId) {
      this.chooseAmount = false;
      this.confirming = true;
      this.$http.post(`${import.meta.env.VITE_LCT_API_URL}/payments`, {
        sessionId,
      }).then(response => response.data).then((result) => {
        this.confirming = false;
        if (result.paid) {
          this.paymentValidated = true;
          // nouveaux jetons : le rôle premium (sans publicité) s'applique tout de suite
          return iam.refreshRole().catch(() => {});
        }
        if (result.status === 'complete') {
          this.paymentPending = true;
        } else {
          this.chooseAmount = true;
          this.paymentError = 'Le paiement n\'a pas abouti : aucun montant n\'a été prélevé.';
        }
        return undefined;
      }).catch(() => {
        this.confirming = false;
        this.errorTitle = 'Vérification du paiement impossible';
        this.paymentError = 'Le paiement n\'a pas pu être vérifié. S\'il a été prélevé, '
          + 'votre compte deviendra prémium dans quelques minutes ; sinon, contactez-nous.';
      });
    },
  },
};
</script>

<style scoped>
  .btn-link {
    color: #CE0F69;
  }
</style>
